import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, trackCustomEvent } from '../utils/analytics';

/**
 * Hook to automatically track page views and provide tracking functions
 */
export const useAnalytics = () => {
  const location = useLocation();
  const lastTrackedPath = useRef(null);

  // Track page view on location change (with deduplication)
  useEffect(() => {
    const currentPath = location.pathname + location.search;

    // Only track if the path actually changed
    if (lastTrackedPath.current !== currentPath) {
      lastTrackedPath.current = currentPath;
      trackPageView(currentPath);
    }
  }, [location]);

  return {
    trackEvent: trackCustomEvent,
  };
};
